import G6 from '@antv/g6';
import {elementNameConst} from '../conf';

/**
 * 拓扑插件-官方内置插件初始化定义
 */


/**
 * Legend 是 G6 内置的图例插件。用于说明图中不同类型的节点和边所代表的含义，并可以通过与图例的交互做简单的高亮和过滤。 v4.3.0 起支持。
 * @returns plugin Legend 对象
 */
export function initLegend() {

}


/**
 * SnapLine 是 G6 内置的对齐线插件。 v4.3.0 起支持。
 * @returns plugin SnapLine 对象
 */
export function initSnapLine() {
  return new G6.SnapLine({
    itemAlignType: true
  });
}


/**
 * Grid 插件在画布上绘制了网格
 * @returns plugin Grid 对象
 */
export function initGrid() {
  return new G6.Grid();
}


/**
 * Minimap 是用于快速预览和探索图的工具。
 * @returns plugin Minimap 对象
 */
export function initMinimap() {
  return new G6.Minimap({
    size: [100, 100],
    className: 'minimap',
    type: 'delegate'
  });
}


/**
 * 由于 Minimap 的原理是将主画布内容复制到 minimap 的画布上，在大数据量下可能会造成双倍的绘制效率成本。
 * 为缓解该问题，Image Minimap 采用另一种机制，根据提供的图片地址或 base64 字符串 graphImg 绘制 <img /> 代替 minimap 上的 canvas。
 * 该方法可以大大减轻两倍 canvas 绘制的压力。
 * 但 graphImg 完全交由 G6 的用户控制，需要注意主画布更新时需要使用 updateGraphImg 方法替换 graphImg。
 * @returns plugin ImageMinimap 对象
 */
export function initImageMinimap() {
  return new G6.ImageMinimap({
    width: 200,
    graphImg: 'https://gw.alipayobjects.com/mdn/rms_f8c6a0/afts/img/A*eD7nT6tmYgAAAAAAAAAAAABkARQnAQ'
  });
}


/**
 * 在关系复杂、繁多的大规模图上，通过边绑定可以降低视觉复杂度。
 * @returns plugin EdgeBundling 对象
 */
export function initEdgeBundling() {

}


/**
 * Menu 用于配置节点上的右键菜单。
 * @returns plugin Menu 对象
 */
export function initMenu() {
  return new G6.Menu({
    className: elementNameConst.defaultMenuClassName,
    itemTypes: ['canvas', 'node', 'edge'],
    shouldBegin(evt, a, b) {
      // console.log(evt, a, b);
      return true;
    },
    getContent(evt, b, c) {
      return '';
    }
  });
}


/**
 * ToolBar 集成了以下常见的操作：
 * 重做；撤销；放大；缩小；适应屏幕；实际大小。
 * @returns plugin ToolBar 对象
 */
export function initToolBar() {
  return new G6.ToolBar({
    position: { x: 10, y: 10 }
  });
}


/**
 * ToolTip 插件主要用于在节点和边上展示一些辅助信息，G6 4.0 以后，Tooltip 插件将会替换 Behavior 中的 tooltip。
 * @returns plugin ToolTip 对象
 */
export function initToolTip() {
  return new G6.Tooltip({
    offsetX: 10,
    offsetY: 20,
    getContent(e) {
      const outDiv = document.createElement('div');
      outDiv.style.width = '180px';
      outDiv.innerHTML = `
      <h4>自定义tooltip</h4>
      <ul>
        <li>Label: ${e.item.getModel().label || e.item.getModel().id}</li>
      </ul>`;
      return outDiv;
    },
    itemTypes: ['node']
  });
}


/**
 * Fisheye 鱼眼放大镜是为 focus+context 的探索场景设计的，它能够保证在放大关注区域的同时，保证上下文以及上下文与关注中心的关系不丢失。
 * @returns plugin Fisheye 对象
 */
export function initFisheye() {

}


/**
 * EdgeFilterLens 边过滤镜可以将关注的边保留在过滤镜范围内，其他边将在该范围内不显示。
 * @returns plugin EdgeFilterLens 对象
 */
export function initEdgeFilterLens() {

}


/**
 * AntV G6 内置了三种形态的 TimeBar 组件：
 * 带有趋势图的 TimeBar 组件；
 * 简易版的 TimeBar 组件；
 * 刻度 TimeBar 组件。
 * 并且每种类型的 TimeBar 组件都可以配合播放、快进、后退等控制按钮组使用。
 * @returns plugin TimeBar 对象
 */
export function initTimeBar() {

}
